import { cn } from "@/utils/cn";
import { Icon } from "./icon";

interface WeatherMenuItemProps {
  item: {
    key: string;
    label: string;
  };
  isActive: boolean;
  onClick: (key: string) => void;
  isDisabled?: boolean;
}

const WeatherMenuItem: React.FC<WeatherMenuItemProps> = ({
  item,
  isActive,
  onClick,
  isDisabled = false,
}) => {
  return (
    <button
      onClick={() => onClick(item.key)}
      disabled={isDisabled}
      type="button"
      className={cn(
        "group relative h-12 text-white flex items-center w-full transition-all duration-200",
        "hover:scale-105 active:scale-95",
        isDisabled && "opacity-50 cursor-not-allowed"
      )}
      aria-label={`${item.label} сонгох`}
      aria-pressed={isActive}
    >
      {/* Background with better hover effects */}
      <span
        className={cn(
          "rounded-full ml-5 pl-10 py-2 pr-4 w-full font-bold text-sm transition-all duration-200",
          "backdrop-blur-sm border border-white/10",
          isActive
            ? "bg-amber-400/60 shadow-lg"
            : "bg-black/40 hover:bg-black/60 group-hover:shadow-md"
        )}
      >
        {item.label}
      </span>

      {/* Icon container with better hover effects */}
      <span
        className={cn(
          "absolute rounded-full w-12 h-12 flex items-center justify-center top-0 left-0",
          "transition-all duration-200 shadow-lg bg-white",
          isActive
            ? "scale-110"
            : "group-hover:scale-105 group-hover:shadow-xl"
        )}
      >
        <Icon
          name={`${item.key}.svg`}
          alt={item.label}
          className="h-6 w-6 transition-transform duration-200 group-hover:scale-110"
        />
      </span>
    </button>
  );
};

export default WeatherMenuItem;
